import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SUBSCRIPTION_LIST = 'GET_SUBSCRIPTION_LIST';
export const GET_SUBSCRIPTION_LIST_SUCCESS = 'GET_SUBSCRIPTION_LIST_SUCCESS';
export const GET_SUBSCRIPTION_LIST_FAILURE = 'GET_SUBSCRIPTION_LIST_FAILURE';

// Action Creators
export const getSubscriptionList = () => ({
  type: GET_SUBSCRIPTION_LIST,
});

export const getSubscriptionListSuccess = (users) => ({
  type: GET_SUBSCRIPTION_LIST_SUCCESS,
  payload: users,
});

export const getSubscriptionListFailure = (error) => ({
  type: GET_SUBSCRIPTION_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSubscriptionListCallApi = (external) => {
  return async (dispatch) => {
    dispatch(getSubscriptionList());
    try {
      const response = await getMethodWithToken(url.subscriptionList);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSubscriptionListSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSubscriptionListFailure(error?.message));
    }
  };
};
